module.exports = __webpack_public_path__ + "static/media/photo227.e4eb58e5.jpg";